// FeedStoryProvider.js
import { connect } from 'react-redux';
import { goBack } from 'redux-first-history';

import { MERGE_OPERATION_DATA } from '../ActionTypes.js';
import {
  SHOWCASE_FEED,
  PAGINATION_ITEM_COUNT_PER_PAGE,
  PAGINATION_ITEM_COUNT_PER_ROW,
} from '../RemoteConfigKeys.js';

import getMeData from '../selector/getMeData.js';
import fetchFeeds from '../action/fetchFeeds.js';
import getListData from '../selector/getListData.js';
import getPaginationData from '../selector/getPaginationData.js';
import getNetworkingData from '../selector/getNetworkingData.js';
import getOperationData from '../selector/getOperationData.js';
import getHomeListItems from '../selector/getHomeListItems.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';

import { sanitizeFeedQuery } from '../resource/feedUtils.js';
import { FeedNameType } from '../resource/feedConstants.js';
import getTranslationKey from '../resource/getTranslationKey.js';

// HACK: make the selectPath with same category be same reference
const selectPathMap = new Map();

const getSelectPath = sanitizedCategory => {
  if (!selectPathMap.has(sanitizedCategory)) {
    selectPathMap.set(sanitizedCategory, [
      'home',
      FeedNameType.MESSAGES,
      sanitizedCategory,
    ]);
  }

  return selectPathMap.get(sanitizedCategory);
};

const mapStateToProps = (
  state,
  { category, titleI18nId: propsTitleI18nId, isInPaginationMode, location }
) => {
  const { search } = location;
  const searchParams = new URLSearchParams(search);
  const currentPage = Number(searchParams.get('page')) || 1;
  const sanitizedCategory = sanitizeFeedQuery({ feedName: category });
  const selectPath = getSelectPath(sanitizedCategory);
  const nextPage = getListData(state, selectPath, 'nextPage');
  const lastPage = getListData(state, selectPath, 'lastPage');
  const totalCount = isInPaginationMode
    ? getPaginationData(state, selectPath, 'totalCount')
    : getListData(state, selectPath, 'totalCount');
  const showcaseFeed = getRemoteConfigData(state, SHOWCASE_FEED);
  const itemCountPerRow = getRemoteConfigData(
    state,
    PAGINATION_ITEM_COUNT_PER_ROW
  );
  const itemCountPerPage = getRemoteConfigData(
    state,
    PAGINATION_ITEM_COUNT_PER_PAGE
  );
  const limit = itemCountPerPage;
  const messageIds =
    sanitizedCategory === 'home'
      ? getHomeListItems(state, showcaseFeed)
      : isInPaginationMode
        ? getPaginationData(
            state,
            selectPath,
            'itemIds',
            undefined,
            limit,
            currentPage
          )
        : getListData(state, selectPath, 'itemIds');
  const badgeName = sanitizedCategory === 'home' ? 'new' : sanitizedCategory;
  const scrollLeft = getOperationData(state, ['home', badgeName], 'scrollLeft');

  return {
    isAuthed: !!getMeData(state, 'token'),
    badgeName,
    moreLink: `/story-categories/${category}`,
    messageIds,
    pinnedItemIds: getListData(
      state,
      ['home', FeedNameType.MESSAGES, sanitizedCategory, 'pinned'],
      'itemIds'
    ),
    isNextPageFetching: !!getNetworkingData(
      state,
      [...selectPath, nextPage],
      'isFetching'
    ),
    isFirstPageFetched: !!getNetworkingData(
      state,
      [...selectPath, 1],
      'isFetched'
    ),
    isCurrentPageFetched: !!getNetworkingData(
      state,
      [...selectPath, currentPage, limit],
      'isFetched'
    ),
    nextPage,
    lastPage,
    totalCount,
    currentPage,
    itemCountPerRow,
    itemCountPerPage,
    deviceWidth: getOperationData(state, ['device'], 'width'),
    maxPlaceholdersAmount: 10,
    category,
    titleI18nId: propsTitleI18nId || getTranslationKey({ key: category }),
    scrollLeft,
    listPath: selectPath,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchFeeds: data => dispatch(fetchFeeds(data)),
    setScrollLeft: ({ scrollLeft, category }) => {
      const sanitizedCategory = sanitizeFeedQuery({ feedName: category });

      return dispatch({
        type: MERGE_OPERATION_DATA,
        payload: {
          selectPath: ['home', sanitizedCategory],
          data: {
            scrollLeft,
          },
        },
      });
    },
    goBack: () => dispatch(goBack()),
  };
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return {
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
    fetchFirstPage: (data = {}) =>
      dispatchProps.fetchFeeds({
        type: ownProps.category,
        unixTimestamp: ownProps.feedUnixTimestamp,
        ...data,
      }),
    fetchNextPage: () =>
      dispatchProps.fetchFeeds({
        page: stateProps.nextPage,
        type: ownProps.category,
        unixTimestamp: ownProps.feedUnixTimestamp,
      }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps);
